import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./assets/css/app.css";
import "./assets/css/bootstrap-grid.min.css";

import "./assets/icons/boxicons-2/css/boxicons.min.css";
import { consumeUrlLoginToken } from "./utils/urlLoginToken";

consumeUrlLoginToken();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
